import React from 'react';
import * as style from './template.module.scss';

interface Props {
    children: JSX.Element | JSX.Element[];
}

const Layout = ({ children }: Props) => (
        <div className={style.container}>
            {children}
        </div>
    );

export default Layout;
